import { colours } from '../../../stylings';

export const featureNames = {
  mens: 'mens',
  womens: 'womens',
  childrens: 'childrens',
  kidsFitting: 'kidsFitting',
  placeOrderInStore: 'placeOrderInStore',
  collectInStore: 'collectInStore',
  originals: 'originals',
};

export function colorizeFeatureTag(featureName: string) {
  switch (featureName) {
    case featureNames.mens:
    case featureNames.womens:
      return {
        bgColor: colours.DARK_GREY,
        fontColor: colours.WHITE,
      };
    case featureNames.childrens:
    case featureNames.kidsFitting:
      return {
        bgColor: colours.TURQUOISE,
        fontColor: colours.BLACK,
      };

    case featureNames.placeOrderInStore:
    case featureNames.collectInStore:
      return {
        bgColor: colours.LIGHT_BLUE,
        fontColor: colours.BLACK,
      };
    case featureNames.originals:
      return {
        bgColor: colours.VIVID_SKY,
        fontColor: colours.BLACK,
      };
    default:
      return {
        bgColor: colours.DARK_GREY,
        fontColor: colours.WHITE,
      };
  }
}
